import React from "react";
import ColFormValueSlider from "./ColFormValueSlider";
import { useController, useFormContext } from "react-hook-form";
import ControlledFormField from "@/model/interface/ControllerRangeSlider";
import { CalculatorField } from "@/model/interface/CalculatorTypes";

const getYearsLeftFields = () => {
  return {
    defaultValue: 0,
    minAmount: 0,
    maxAmount: 30,
  };
};

const fieldName = CalculatorField.YearsLeftOnMortgage;
const MortgageYearsLeft: React.FC<ControlledFormField> = ({ fieldPrefix }) => {
  const { defaultValue, ...minMaxParams } = getYearsLeftFields();

  const { control } = useFormContext();

  const { field } = useController({
    control,
    name: [fieldPrefix, fieldName].filter(Boolean).join("."),
    defaultValue,
  });

  return (
    <ColFormValueSlider
      title="Years left on mortgage"
      step={1}
      value={field.value}
      {...minMaxParams}
      rightColumnValue={field.value ?? 0}
      onFinalChange={field.onChange}
      onChange={field.onChange}
    />
  );
};

export default MortgageYearsLeft;
